import { Content } from '../../types';

export const ninhBinhContent: Content = {
  title: 'נין בין - פנינת הטבע של צפון וייטנאם',
  imageUrl: '/images/vietnam/ninh-binh/ninh-binh-wide.jpeg',
  introduction:
    'נין בין הינו מחוז קסום בצפון וייטנאם, המרוחק כשעתיים נסיעה דרומית להאנוי. הוא מציע למבקרים שילוב יוצא דופן של נופים עוצרי נשימה, היסטוריה עתיקה ותרבות מקומית מרתקת. העיר המרכזית במחוז נקראת אף היא נין בין, אך עיקר העניין התיירותי מתמקד בעיירה הקטנה טאם קוק ובסביבתה.',
  sections: [
    {
      title: 'נוף עוצר נשימה - "האלונג ביי של היבשה"',
      type: 'text',
      content:
        'האזור זכה לכינוי "האלונג ביי של היבשה" בזכות צוקי הגיר הדרמטיים המתרוממים מתוך שדות האורז הירוקים והנהרות השקטים ויוצרים נוף מהפנט וייחודי. ברחוב הראשי של טאם קוק ניתן למצוא מסעדות מקומיות רבות וכן מבחר בתי הארחה משפחתיים המציעים אירוח חם ואותנטי.',
    },
    {
      title: 'האטרקציות המרכזיות באזור',
      type: 'list',
      content: [
        {
          subtitle: 'שיט בנהר Ngo Dong',
          text: 'האטרקציה הפופולרית ביותר באזור הינה שייט בסירת משוטים על נהר Ngo Dong. השייט מבוצע בסירות קטנות המושטות באופן ייחודי על ידי חתירה ברגליים, דרך מערכת של מערות טבעיות ונופים ציוריים. ניתן לצאת לשיט משני מקומות עיקריים:\n\nטאם קוק - מסלול השיט המרכזי, הכולל שלוש מערות טבעיות (Hang Ca, Hang Hai, Hang Ba) ומעבר בין שדות אורז ציוריים.\n\nTrang An - אזור נוסף לשיט הכולל רשת של מערות ומקדשים נסתרים, עם נוף מרשים עוד יותר ותחושה פחות תיירותית.',
        },
        {
          subtitle: 'הר Hang Mua - נקודת תצפית מרהיבה',
          text: 'אחת מנקודות החובה בטיול לנין בין הינה הר Hang Mua, המציע תצפית עוצרת נשימה על הנוף הסובב. הטיפוס לפסגה כולל כ-500 מדרגות תלולות, אך הנוף הנשקף ממנה - של הנהר המתפתל בין הצוקים הגבוהים - שווה כל מאמץ. מהפסגה ניתן לראות את אזור טאם קוק במלוא הדרו וליהנות משתי נקודות תצפית שונות, כל אחת מרשימה בדרכה.',
        },
        {
          subtitle: 'מתחם Hoa Lu - הצצה להיסטוריה של וייטנאם',
          text: 'Hoa Lu היתה בעבר הבירה הראשונה של וייטנאם במאה ה-11 וכיום נותרו בה שרידים של מקדשים עתיקים, פגודות ותעלות הגנה היסטוריות. האתר מציע חוויה תרבותית והיסטורית מרתקת, במיוחד עבור חובבי היסטוריה וארכיטקטורה וייטנאמית מסורתית.',
        },
        {
          subtitle: 'הפארק הלאומי Cuc Phuong',
          text: 'לחובבי טבע והרפתקאות מומלץ מאוד לבקר בפארק הלאומי Cuc Phuong - הפארק הלאומי הראשון והגדול ביותר בוייטנאם. הפארק מציע מגוון מסלולי הליכה דרך יערות גשם עבותים, בתי גידול לחיות בר נדירות וביקור במרכז לשימור קופי לאנגור בסכנת הכחדה. חובבי טרקים ימצאו כאן מסלולים שונים בדרגות קושי מגוונות.',
        },
      ],
    },
    {
      title: 'אטרקציות נוספות באזור טאם קוק',
      type: 'list',
      content: [
        {
          subtitle: 'פגודת Bich Dong',
          text: 'פגודת Bich Dong הינה פגודה ציורית החצובה בצוקי הגיר ומשתלבת באופן מרהיב עם הנוף הטבעי. הפגודה מורכבת משלושה מבנים - תחתון, אמצעי ועליון - וכל אחד מהם מציע חוויית ביקור מיוחדת עם נוף פנורמי קסום.',
        },
        {
          subtitle: 'ואן לונג (Van Long Nature Reserve)',
          text: 'שמורת הטבע ואן לונג הינה אופציה שקטה ומבודדת יותר לשייט בנוף דומה לזה של טאם קוק, אך עם פחות תיירים. כאן ניתן לראות חיות בר ייחודיות, כולל קופי לאנגור נדירים וציפורים אקזוטיות וליהנות מהאווירה הפסטורלית של המקום.',
        },
        {
          subtitle: 'פגודת Bai Dinh',
          text: 'הפגודה הגדולה ביותר בוייטנאם, Bai Dinh, הינה אתר מרשים עם מקדשים בודהיסטיים עצומים, פסלים מוזהבים ותצפיות נרחבות על האזור כולו. הביקור בפגודה מספק חוויה רוחנית ותרבותית מיוחדת.',
        },
      ],
    },
    {
      title: 'טיפים לטיול בנין בין',
      type: 'list',
      content: [
        {
          subtitle: 'משך השהות מומלץ',
          text: 'לפחות יומיים - שלושה, על מנת להספיק ליהנות מכל האתרים המרכזיים ולהימנע מחוויית טיול חפוזה.',
        },
        {
          subtitle: 'תחבורה',
          text: 'הדרך הטובה ביותר להתנייד באזור הינה באמצעות השכרת אופניים או קטנועים, המאפשרים גישה נוחה לכל האטרקציות.',
        },
        {
          subtitle: 'מתי להגיע?',
          text: 'העונה הטובה ביותר לביקור באזור הינה בין ספטמבר לאפריל, כאשר מזג האוויר נעים יותר ושדות האורז בשיא יופיים.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, נין בין הינו יעד חובה למבקרים בצפון וייטנאם ומשלב בין טבע עוצר נשימה, היסטוריה עשירה וחוויה תרבותית ייחודית. בין אם תבחרו לצאת לשיט קסום, לטפס לנקודת תצפית עוצרת נשימה או לטייל בפארקים הלאומיים - האזור יכבוש אתכם ביופיו וייחודו.',
    },
  ],
};
